import GeneralModal from "../../../../utils/GeneralModal";

export default function StoryTimeDeleteModal({
  open,
  close,
  handleDelete,
}: {
  open: boolean;
  close: any;
  handleDelete: any;
}) {
  return (
    <>
      <GeneralModal
        title={"Are you sure you want to delete the item?"}
        open={open}
        close={close}
        isConfirm={false}
        isDeletion
        width={417}
        handleDelete={handleDelete}
        text={"All uploaded content and related sub-items will be permanently removed"}
      />
    </>
  );
}
